import { Application } from "../lib/ui/Application.js";
import { UploadPanel } from "./modules/core/UploadPanel.js";
import { initialize as initializeAppDatatypes } from "./data/app-datatypes.js";
import { endpoints } from "./modules/core/core-api-endpoints.js";

export class App extends Application {

    constructor(options = {}) {

        super(options);

        this.blockingOperationStarted = super.setBusyFlag;
        this.blockingOperationFinished = super.clearBusyFlag;

        this.dataStorage = this.getServices().getStorage();
        initializeAppDatatypes();

        // controls & components

        this.uploadPanel = new UploadPanel(this, {
            uploadFragmentPath: endpoints.fileUpload.uploadFragment,
            mergeFragmentsPath: endpoints.fileUpload.mergeFragments,
            httpClient: this.getServices().getHttpService(),
        });

    };

    // prepare() {

    //     return super.prepare()
    //         .then(() => {

    //             let loggedUser = authManager.refreshLoggedUser();

    //             if (!loggedUser)
    //                 return Promise.resolve(false);

    //             return Promise.resolve(true);

    //             // return Promise.all([
    //             // ]);

    //         });

    // };

    // --------------------------------------------------------------------------------------------

    showOffCanvasMenu() {

        this.mainMenu.active = true;
        this.invalidate();

    }

    hideOffCanvasMenu() {

        this.mainMenu.active = false;
        this.invalidate();

    }

    openProjectSelectionModule() {

        this.routeTo('select-active-project');

    };

    openLoginModule() {

        this.routeTo('auth-login');

    };

    openAccountDetailsModule() {

        this.routeTo('account-account-details');

    };

    // --------------------------------------------------------------------------------------------

    getUploadPanel() {

        return this.uploadPanel;

    };

    moduleChanged(module) {

        this.mainMenu.active = false;
        super.moduleChanged(module);

    };

    // --------------------------------------------------------------------------------------------

    _render(r, vm) {

        const services = this.getServices();
        const app = this;
        const authManager = services.getAuthManager();
        const i18n = services.getI18n();

        let activeModule = this.getAcitveModule(),
            appName = 'Tunnel Design',
            loggedUser = authManager.getUser();

        const moduleNode = activeModule ? activeModule.render(r, vm) : r.module(null, ['No active module']);
        const moduleTitle = activeModule ? activeModule.getModuleTitle() : '';

        return r.app({}, concat([

            // top header

            r.header(null, [
                r.nav(null, concat([
                    renderAppHeaderLeftNavbar(),
                    r.span('max'),
                    renderAppHeaderRightNavbar(),
                    renderAppHeaderOffCanvasDropdown()
                ])),
            ]),
            moduleNode,
            renderMainMenu(),
            app.controls.map((control) => control.render(r, vm)),

        ]));

        function concat(controls) {

            if (!controls)
                return [];
            if (!Array.isArray(controls))
                controls = [controls];
            return controls.reduce((result, item) => result.concat(item), []);

        }

        function renderAppHeaderRightNavbar() {

            return concat([
                collectUserActions().map((action) => {

                    switch (action.appereance) {
                        case 'icon':
                            return r.iconButton(action.icon, { css: `${action.css || ''} circle transparent l xl`, props: { type: 'button', title: action.hint, onclick: action.handler } });
                        case 'chip':
                            return r.button(action.label, action.icon, { css: `${action.css || ''} chip l xl`, props: { type: 'button', title: action.hint, onclick: action.handler } });
                        default:
                            return r.button(action.label, action.icon, { css: `${action.css || ''} l xl`, props: { type: 'button', title: action.hint, onclick: action.handler } });
                    }

                }),
                r.dropdownButton(null, '#language', { buttonCss: 'circle transparent l xl', props: { type: 'button' } },
                    collectLangActions().map((action) => {
                        return r.menuItem(null, null, null, null, [r.link({ props: { onclick: action.handler } }, [action.label])]);
                    })
                ),
            ]);

        }

        function renderAppHeaderOffCanvasDropdown() {

            // created again becaus of use in different part of DOM tree - DOM.removeChild() problem

            return [
                r.dropdownButton(null, '#options-vertical', { buttonCss: 'circle transparent xs s m', props: { type: 'button' } },
                    concat([
                        collectLangActions(),
                        collectUserActions(),
                    ]).map((action) => {

                        let controls = [];

                        if (action.icon)
                            controls.push(r.icon(action.icon));
                        if (action.label)
                            controls.push(action.label);

                        return r.menuItem(null, null, null, null, [r.link({ props: { onclick: action.handler } }, controls)]);

                    })
                )
            ];

        }

        function collectLangActions() {

            return app.getAvailableLocales().map((def) => {

                return {
                    label: def.name,
                    hint: def.name,
                    handler: (e) => { app.setLocale(def.code); }
                };

            });

        };

        function collectUserActions() {

            if (!loggedUser) {

                return [
                    {
                        label: i18n.t('app.label_login'),
                        icon: '#login',
                        hint: i18n.t('app.label_login'),
                        handler: (e) => { app.openLoginModule(); },
                        appereance: 'icon'
                    },
                ];

            }

            let userName = (loggedUser.firstName || '') + ' ' + (loggedUser.lastName || '').toUpperCase(),
                userUsername = loggedUser.username,
                userDisplayName = userName != ' ' ? userName : userUsername;

            return [
                {
                    label: userDisplayName,
                    icon: '#user',
                    handler: (e) => { app.openAccountDetailsModule(); },
                    //appereance: 'chip'
                    css: 'button text'
                },
                {
                    label: i18n.t('app.label_logout'),
                    icon: '#logout',
                    hint: i18n.t('app.label_login'),
                    handler: (e) => { authManager.logout(); },
                    appereance: 'icon'
                },
            ];

        };

        /**
         * @returns array of domVM nodes
         */
        function renderAppHeaderLeftNavbar() {

            let controls = [
                r.iconButton('#menu', { css: 'circle transparent', props: { type: 'button', onclick: () => { app.showOffCanvasMenu(); } } }),
                r.h4('truncate', [
                    appName + (moduleTitle ? ` - ${moduleTitle}` : ''),
                ]),
            ];

            return controls;

        };

        function renderMainMenu() {

            const visible = app.mainMenu.isActive();

            return [
                r.div([
                    r.el('div', visible ? 'overlay active' : 'overlay', { onclick: (e) => { app.hideOffCanvasMenu(); } }),
                    r.el('dialog', `left medium-width no-scroll ${visible ? 'active' : ''}`, null, [
                        r.stack({ css: 'vertical full-height' }, [
                            r.row({ css: 'min' }, [
                                r.span('max'),
                                r.iconButton('#close', { css: 'circle transparent', props: { type: 'button', onclick: (e) => { app.hideOffCanvasMenu(); } } }),
                            ]),
                            r.div('scroll-y', [
                                app.mainMenu.render(r, vm),
                            ]),
                        ])
                    ]),
                ]),
            ];

        };


    };

}
